module.exports = __webpack_public_path__ + "img/auto.6d6f584d.png";